export default __webpack_public_path__ + "static/media/tl.2906e09e.svg";